'use client'

import Image from 'next/image'
import Typography from 'src/components/design-system/Typography'
import { getMediaUrl } from 'src/_helpers/client/getMediaUrl'
const LogotypeItem = ({ title, alt, thumb, className = '' }) => {
  const thumbUrl = thumb ? getMediaUrl(thumb.url, thumb.version) : null
  return (
    <div className={`${className}`}>
      <div className="flex flex-col justify-end gap-y-12">
        {thumb && thumbUrl && (
          <div className="relative aspect-[174/104] w-[80%]">
            <Image src={thumbUrl} fill alt={alt || ' '} className="h-full w-full object-contain object-bottom-left" />
          </div>
        )}
        {title && (
          <Typography variant="body4" color="text-basic-black">
            {title}
          </Typography>
        )}
      </div>
    </div>
  )
}

export { LogotypeItem }
